export default __webpack_public_path__ + "static/media/mg-girl.8e027240.webp";